export default {"src":"/evde-internet/_next/static/media/infowhite.7220cb06.svg","height":24,"width":24};